import axios from 'axios';



const NEW_BASE_URL = 'https://uponorna.secure.force.com/uponoropendata/services/apexrest/REST/findaninstaller/v1?'

const BASE_STATIC_URL = 'https://phyn-uponorna.cs14.force.com/uponoropendata/services/apexrest/REST/findaninstaller/v1?queryFor=phyn_certified_installer&lat=44.894354&lng=-93.450439';



class ApiService {

  constructor() {
  	this.setupInstance();
  };



  setupInstance = () => {
     var data = {};
     	this.axios = axios.create(data);
     };
      
  create = () => {
    var data = {};
    	return axios.create(data);
    }
    

  setPlumberURL = (lat, lng) => {
    const URL = NEW_BASE_URL + 'lat=' + lat + '&lng=' + lng + '&queryFor=Phyn_Certified_Installer'
    return this.axios.get(URL)

  };
}

export default new ApiService();


// WEBPACK FOOTER //
// ./src/services/ApiService.js